import { useContext } from 'react';

import { RefreshContext, type RefreshContextType } from '../contexts/refresh';

export const useRefresh = (): RefreshContextType => {
  const context = useContext(RefreshContext);

  if (context === undefined) {
    throw new Error('useRefresh must be used within a RefreshProvider');
  }

  return context;
};
